import { API } from "../constants";

import {
  createRequestAction,
  createSuccessAction,
  createFailureAction,
} from "../index";
import { freshV4Token } from "../V4client";

const api = async (store, action) => {
  store.dispatch(createRequestAction(action));

  let reqBody;

  if (action.body instanceof FormData) {
    reqBody = action.body;
  } else {
    reqBody = action.body ? JSON.stringify(action.body) : null;
  }

  // Signed like V4client's securityWorker; the store's copy misses another tab's renewal.
  const token = (await freshV4Token()) || store.getState().API.get("token");

  if (!action.headers) action.headers = {};

  if (token) {
    action.headers["Authorization"] = `Bearer ${token}`;
  }

  if (reqBody) {
    action.headers["Content-Type"] = "application/json";
  }

  try {
    const result = await fetch(action.url, {
      method: action.method,
      body: reqBody,
      headers: action.headers,
    });
    let body = result.statusText;

    if (
      result.headers.get("content-type") &&
      result.headers.get("content-type").indexOf("application/json") !== -1
    ) {
      body = await result.json();
    }

    if (process.env.NODE_ENV !== "production") console.log(body);

    if (result.ok) {
      store.dispatch(createSuccessAction(action, body, result.status));

      return body;
    }

    const failureAction = {
      error: body?.error || body || "GENERAL_ERROR",
      status: result.status,
    };

    store.dispatch(createFailureAction(action, failureAction));

    return failureAction;
  } catch (e) {
    console.log(e);
    store.dispatch(createFailureAction(action, e));

    return { ...action, error: e.toString() };
  }
};

function apiMiddleware(store) {
  return (next) => (action) => {
    if (action.type !== API) return next(action);

    return api(store, action);
  };
}

export default apiMiddleware;
